import { defineMessages } from 'react-intl';

export default defineMessages({
    vendorsInvolved: {
        id: 'claim.views.claim-detail.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    },
    LossDescription: {
        id: "claim.views.claim-detail.Loss Description",
        defaultMessage: "Loss Description"
    },
    ContactPerson: {
        id: "claim.views.claim-detail.Contact Person",
        defaultMessage: "Contact Person"
    },
    PrimaryEmail: {
        id: "claim.views.claim-detail.Primary Email",
        defaultMessage: "Primary Email"
    },
    PrimaryPhone: {
        id: "claim.views.claim-detail.Primary Phone",
        defaultMessage: "Primary Phone"
    },
    LossItems: {
        id: "claim.views.claim-detail.Loss Items",
        defaultMessage: "Loss Items"
    },
    ClaimStatus: {
        id: "claim.views.claim-detail.claimStatus",
        defaultMessage: "Claim Status"
    },
    ClaimContactUs: {
        id: "claim.views.claim-detail.ContactUs",
        defaultMessage: "Contact Us"
    },
    ClaimsAdjusterName: {
        id: "claim.views.claim-detail.ClaimsAdjusterName",
        defaultMessage: "Adjuster"
    },
    ClaimsPrimaryInsured: {
        id: "claim.views.claim-detail.Primary Insured",
        defaultMessage: "Primary Insured"
    },
    ClaimAdditionalInsured: {
        id: "claim.views.claim-detail.Additional Insured",
        defaultMessage: "Additional Insured"
    }, 
    ClaimSendMesssage: {
        id: "claim.views.claim-detail.Send Messsage",
        defaultMessage: "Send Messsage"
    },
    ClaimMesssages: {
        id: "claim.views.claim-detail.Messsages",
        defaultMessage: "Messsages"
    },
    ClaimNewMesssage: {
        id: "claim.views.claim-detail.New Messsage",
        defaultMessage: "New Messsage"
    }


});
